


























































































import { Component, Mixins } from 'vue-property-decorator';
import QuestionMixins from '@/mixins/QuestionMixins';
import { mapState } from 'vuex';
import QQuestionnaireResultLayout from '@/components/Questionnaire/QQuestionnaireResultLayout.vue';
import QDownloadBtn from '@/components/QDownloadBtn.vue';
import { STATUSES as QUESTIONNAIRE_ANSWER_STATUSES } from '@/constants/questionnaire_answer';
import _ from 'lodash';
import { BOOKING_PURPOSES } from '../../../constants/booking';

@Component({
  components: {
    QQuestionnaireResultLayout,
    QDownloadBtn,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('QuestionnaireAnswer', {
      questionnaireAnswer: 'questionnaireAnswer',
      questionnaire: 'questionnaire',
    }),
    ...mapState('BookingCandidate', {
      bookingCandidate: 'bookingCandidate',
    }),
  },
})
export default class BookingCandidateReadQuestionnaireResult extends Mixins(
  QuestionMixins
) {
  questionnaireAnswer!: Model;
  questionnaire!: Model;
  bookingCandidate!: Model;

  isMounted = false;
  activeIndex = 0;
  questionnaireAnswerStatuses = QUESTIONNAIRE_ANSWER_STATUSES;
  bookingPurposes = BOOKING_PURPOSES;

  async beforeMount() {
    await this.$store.dispatch(
      'QuestionnaireAnswer/fetch',
      this.bookingCandidate.object_id
    );
    this.isMounted = true;
  }

  beforeDestroy() {
    this.$store.commit('QuestionnaireAnswer/CLEAR_STATE');
  }

  get questionGroups() {
    return this.questionnaire.question_groups.map(
      this.$store.getters['Questionnaire/mapQuestionGroup']
    );
  }

  get name() {
    if (!this.bookingCandidate.first_name && !this.bookingCandidate.last_name) {
      return null;
    }
    return (
      (this.bookingCandidate.first_name ?? '') +
      ' ' +
      (this.bookingCandidate.last_name ?? '')
    );
  }

  toReport() {
    this.$router.push({
      name: 'candidate-booking-candidate-report',
      params: {
        bookingCandidateOid: this.bookingCandidate.object_id as string,
        questionnaireAnswerOid: this.questionnaireAnswer.object_id as string,
      },
    });
  }

  toHCSReport() {
    this.$router.push({
      name: 'candidate-booking-candidate-health-check-summary',
      params: {
        bookingCandidateOid: this.bookingCandidate.object_id as string,
        questionnaireAnswerOid: this.questionnaireAnswer.object_id as string,
      },
    });
  }

  toDownloadReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadReport',
        this.questionnaireAnswer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  toDownloadAttachedReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadAttachedReport',
        this.questionnaireAnswer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  toDownloadHCSReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadHCSReport',
        this.questionnaireAnswer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  get isQuestionnaireCompleted() {
    if (
      this.questionnaireAnswer?.status &&
      [this.questionnaireAnswerStatuses.STATUS_COMPLETED.key].includes(
        this.questionnaireAnswer.status
      )
    ) {
      return true;
    }
    return false;
  }

  get showAutoGeneratedResult() {
    if (this.isQuestionnaireCompleted) {
      return true;
    }
    return false;
  }

  get showHCSResult() {
    if (
      this.isQuestionnaireCompleted &&
      !this.questionnaireAnswer?.is_awaiting_report &&
      this.bookingCandidate.booking.purpose ==
        this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    ) {
      return true;
    }
    return false;
  }

  get showAttachedResult() {
    if (
      this.isQuestionnaireCompleted &&
      !this.questionnaireAnswer?.is_awaiting_report &&
      !_.isEmpty(this.questionnaireAnswer?.report)
    ) {
      return true;
    }
    return false;
  }

  get fullReportName() {
    if (
      !this.bookingCandidate.booking.purpose ||
      this.bookingCandidate.booking.purpose ==
        this.bookingPurposes.PURPOSE_PRE_EMPLOYMENT.key
    ) {
      return 'Your Responses';
    }

    return 'Full Report';
  }
}
